import { getEmailDomain, getEmailUsername } from '@rewardopl/utils/email';

import commonTypos from '../common_typos.json';

/**
 * Checks if an email domain is a typo and returns the suggested correction
 *
 * @param {string} email The email address to check
 * @returns {string | null} The suggested correction or null if no typo is found
 */
export function correctEmailTypo(email: string): string | null {
  try {
    const username = getEmailUsername(email);
    const domain = getEmailDomain(email);

    for (const [correctDomain, typos] of Object.entries(commonTypos)) {
      if (typos.includes(domain)) {
        return `${username}@${correctDomain}`;
      }
    }
  } catch {}

  return null;
}
